import store from "@/store/index";
import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";

import permissions from "@/router/userPermissions";
import { isUrlScope } from "@/utils/helpers";
import adminRoutes from "@/modules/cardioguard-admin/router";
import trainerRoutes from "@/modules/cardioguard-trainer/router";

Vue.use(VueRouter);

let routes;

const baseRoutes = [
  {
    path: "",
    component: () => import("@/layouts/intranet-empty/Index.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/Home"),
        meta: {
          auth: permissions.scopes.all,
          title: "Bienvenid@ al panel de administración de Paradise",
        },
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/layouts/intranet-empty/Index.vue"),
    children: [
      {
        path: "",
        name: "login",
        component: () => import("@/views/UserLogin.vue"),
        meta: {
          auth: permissions.roles.guest,
          title: "Acceso de usuario",
        },
      },
    ],
  },
];
const notFoundRoute = [
  {
    path: "*",
    component: () => import("@/views/errors/404.vue"),
  },
];

if (isUrlScope("/admin")) {
  routes = [...baseRoutes, ...adminRoutes, ...notFoundRoute];
} else if (isUrlScope("/trainer")) {
  routes = [...baseRoutes, ...trainerRoutes, ...notFoundRoute];
} else {
  routes = [...baseRoutes, ...notFoundRoute];
}

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === undefined) {
    // 404 paths
    next();
  } else {
    let allowedRoles = to.matched.map(record => record.meta.auth).filter(record => record);
    if (allowedRoles.length > 1) {
      // Only one auth can be used per path
      return null;
    }

    const loggedIn = Cookies.get("auth_token") && store.state.user.loggedIn;

    if (loggedIn) {
      if (allowedRoles[0] === "guest") {
        next(from.path);
      } else {
        const userRoles = store.state.user.roles.map(role => role.id);
        const authorized = allowedRoles
          .flat()
          .filter(allowedRole => userRoles.includes(allowedRole));
        if (authorized.length) {
          next();
        } else {
          from.name === "login"
            ? next({ name: "dashboard", query: { forbidden: 1 } })
            : next({ path: from.fullPath, query: { forbidden: 1 } });
        }
      }
    } else {
      if (store.state.user.loggedIn) store.commit("CLEAR_USER_DATA");

      if (!allowedRoles.length || allowedRoles[0] === "guest") {
        next();
      } else {
        store.state.loginRedirect = to.fullPath;
        next({ name: "login" });
      }
    }
  }
});

export default router;
